/**
 * 評価（1〜3 段階）の良かった／残念だったの判定と、良かった率の表示文言（unit-dashboard#1677 RP-8 §1）。
 *
 * - 表示の正本は API の `RatingSummaryObject.goodRate`（整数 %）。画面で件数から率を再計算しない。
 * - `toGoodRatePercent` は API（unit-api-spec#219）と同じ丸め規則をフロントに 1 か所だけ残すための関数で、
 *   fixture・テストの期待値づくりに使う。表示には使わない。
 * - 規則は IF アプリ（unit-app-front#999 RI-1 の `isGoodRating` / `calcGoodRatePercent`）と同じ。
 */

/** 評価値 2 も「良かった」に含める（入力フォームの RatingRadio・既存の `rating >= 2` と同じ判定） */
export const isGoodRating = (rating: number): boolean => rating >= 2;

/** 1 件の評価の表示文言 */
export const ratingResultLabel = (rating: number): "良かった" | "残念だった" =>
  isGoodRating(rating) ? "良かった" : "残念だった";

/** API の整数 % をそのまま「92%」にする（丸め・桁区切りはしない） */
export const formatGoodRate = (rate: number): string => `${rate}%`;

/**
 * 良かった率（整数 %、四捨五入）。評価が 0 件のときだけ null。
 * `goodCount / ratingCount * 100` の順だと 29 / 200 が 14.499… になって 14 に丸まるため、掛け算を先にする（API と同じ）。
 */
export const toGoodRatePercent = (goodCount: number, ratingCount: number): number | null => {
  if (ratingCount === 0) return null;
  return Math.round((goodCount * 100) / ratingCount);
};
